import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Parallax, Navigation } from "swiper/modules";
import Image from 'next/image';
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoPython } from "react-icons/bi";

const BusinessAnalyticsTools = () => {
    const { t } = useTranslations();
    return (
        <section className="partner-area ptb-100 ba-tools">
            {/* Hintergrund-Dekoration */}
            <div className="ba-tools__decoration ba-tools__decoration--top-left"></div>
            <div className="ba-tools__decoration ba-tools__decoration--bottom-right"></div>

            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12">
                        <div className="partner-title text-center mb-5">
                            <span className="ba-tools__badge">
                                {t("businessAnalytics_tools_subtitle")}
                            </span>
                            <h2 className="ba-tools__title">
                                {t("businessAnalytics_tools_title")}
                            </h2>
                            <p className="ba-tools__description">
                                {t("businessAnalytics_tools_description")}
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="ba-tools__slider-container">
                            <Swiper
                                style={{
                                    '--swiper-navigation-color': '#59bd65',
                                    '--swiper-pagination-color': '#59bd65',
                                }}
                                speed={900}
                                parallax={true}
                                pagination={{
                                    clickable: true,
                                    dynamicBullets: true,
                                }}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                modules={[Parallax, Pagination, Navigation, Autoplay]}
                                className="webdevswiper"
                            >
                                <SwiperSlide>
                                    <div className="about-content text-center">
                                        <div className="ba-tools__icon-wrapper ba-tools__icon-wrapper--green">
                                            <Image
                                                src="/images/business-analytics/power-bi-logo.png"
                                                alt="simplify data - power bi"
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <span className="ba-tools__slide-title" data-swiper-parallax="-200">
                                            {t("businessAnalytics_tools_powerBi_title")}
                                        </span>
                                    </div>
                                    <div className="ba-tools__slide-text" data-swiper-parallax="-100">
                                        <p>
                                            {t("businessAnalytics_tools_powerBi_description")}
                                        </p>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="about-content text-center">
                                        <div className="ba-tools__icon-wrapper ba-tools__icon-wrapper--blue">
                                            <Image
                                                src="/images/business-analytics/metabase/metabase-logo.svg"
                                                alt="simplify data - metabase"
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <span className="ba-tools__slide-title" data-swiper-parallax="-200">
                                            {t("businessAnalytics_tools_metabase_title")}
                                        </span>
                                    </div>
                                    <div className="ba-tools__slide-text" data-swiper-parallax="-100">
                                        <p>
                                            {t("businessAnalytics_tools_metabase_description")}
                                        </p>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="about-content text-center">
                                        <div className="ba-tools__icon-wrapper ba-tools__icon-wrapper--red">
                                            <Image
                                                src="/images/icon1.png"
                                                alt="simplify data - process mining"
                                                width={40}
                                                height={40}
                                            />
                                        </div>
                                        <span className="ba-tools__slide-title" data-swiper-parallax="-200">
                                            {t("businessAnalytics_tools_processMining_title")}
                                        </span>
                                    </div>
                                    <div className="ba-tools__slide-text" data-swiper-parallax="-100">
                                        <p>
                                            {t("businessAnalytics_tools_processMining_description")}
                                        </p>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="about-content text-center">
                                        <div className="ba-tools__icon-wrapper ba-tools__icon-wrapper--orange">
                                            <BiLogoPython style={{ width: '50px', height: '50px' }} />
                                        </div>
                                        <span className="ba-tools__slide-title" data-swiper-parallax="-200">
                                            {t("businessAnalytics_tools_statistics_title")}
                                        </span>
                                    </div>
                                    <div className="ba-tools__slide-text" data-swiper-parallax="-100">
                                        <p>
                                            {t("businessAnalytics_tools_statistics_description")}
                                        </p>
                                    </div>
                                </SwiperSlide>

                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BusinessAnalyticsTools;
